<ng-template #createUser let-modal>
  <div class="modal-content">
    <div class="modal-header p-3">
      <h4 class="card-title mb-0">{{ title }}</h4>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="createForm" (ngSubmit)="onSubmit()">
        <div class="mb-3">
          <label for="email" class="form-label">Email <span class="text-danger">*</span></label>
          <input type="email" class="form-control" id="email" placeholder="Enter email address" required formControlName="email" [ngClass]="{ 'is-invalid': submitted && f['email'].errors }">
          <div class="invalid-feedback"> Please enter email </div>
        </div>
        <div class="mb-3">
          <label for="roles" class="form-label">Roles <span class="text-danger">*</span></label>
          <ng-select [items]="roles" [multiple]="true" bindLabel="name" bindValue="code" placeholder="Select Roles" [(ngModel)]="selectedRoles" [ngModelOptions]="{standalone: true}" [ngClass]="{ 'is-invalid': submitted && selectedRoles.length === 0 }">
            <ng-template ng-optgroup-tmp let-item="item">
              {{ item.name }}
            </ng-template>
          </ng-select>
          <div class="invalid-feedback"> Please select at least one role </div>
        </div>
        <div class="text-end">
          <button type="submit" class="btn btn-primary btn-load" [disabled]="spinner">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''"> {{ button_text }} </span>
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #changeStatusUser let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
        @if (state_mode === 'remove') {
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
        }
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you sure you want to {{ button_text | titlecase }}</h4>
          @if (selectedUser) {
            <h4><span class="fw-semibold text-warning">{{ selectedUser.user.person.first_name ? selectedUser.user.person.first_name + ' ' + selectedUser.user.person.last_name : selectedUser.user.email }}</span>?</h4>
          }
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
        <button type="button" [ngClass]="state_mode === 'activate' ? 'btn-success' : 'btn-danger'" class="btn w-sm btn-load" [disabled]="spinner" (click)="onSubmit()">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''">{{ button_text }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #reInviteUser let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/vpbspaec.json" trigger="loop" colors="primary:#6c16c7,secondary:#08a88a" style="width:100px;height:100px"></lord-icon>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          @if (state_mode !== 'create') {
            <h4>Are you sure you want to {{ button_text | titlecase }}</h4>
          }
          @if (selectedUser) {
            <h4><span class="fw-semibold text-warning">{{ selectedUser.user.person.first_name ? selectedUser.user.person.first_name + ' ' + selectedUser.user.person.last_name : selectedUser.user.email }}</span>?</h4>
          }
          @if (state_mode === 'create') {
            <h4>previously removed, Are you sure you want to recover that user?</h4>
          }
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
        <button type="button" class="btn w-sm btn-primary btn-load" (click)="reinvite()" [disabled]="spinner">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''">{{ state_mode === 'create' ? 'Invite' : button_text }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        <h4 class="mb-3 mt-4">User was {{ status }} successfully.</h4>
        <p class="text-muted fs-15 mb-4">{{ successMessage }}</p>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #errorModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        <lord-icon src="https://cdn.lordicon.com/jxzkkoed.json" trigger="loop" style="width:150px;height:150px"></lord-icon>
        <h4 class="mb-3 mt-4">No Subscription Found</h4>
        <p class="text-muted fs-15 mb-4">You can not {{ state_mode }} without an active subscription!</p>
      </div>
    </div>
  </div>
</ng-template>